const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export function randomString(count = 8) {
    let text = ''
    for (var i = 0; i < count; i++)
        text += CHARS.charAt(Math.floor(Math.random() * CHARS.length))

    return text
}
